import React, { useState } from 'react';
import { Button } from '../../design-system/Button';
import { coachOnboardingAPI } from '../../../api/coachApi';

interface PricingStepProps {
  onComplete: () => void;
  onSkip?: () => void;
  progress?: any;
}

const PricingStep: React.FC<PricingStepProps> = ({ onComplete }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError('');
      
      // Submit basic pricing structure
      await coachOnboardingAPI.setupPricing({
        pricing_tiers: [
          {
            name: 'Discovery Session',
            price: 0,
            duration: 30,
            description: 'Free initial consultation',
          },
          {
            name: 'Standard Session',
            price: 50,
            duration: 60,
            description: 'Regular coaching session',
          },
        ],
        payment_methods: ['credit_card'],
        cancellation_policy: {
          notice_hours: 24,
          refund_percentage: 100,
        },
      });
      
      onComplete();
    } catch (err: any) {
      setError(err.message || 'Failed to update pricing');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
          {error}
        </div>
      )}

      <div className="text-center py-8">
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Pricing & Services
        </h3>
        <p className="text-gray-600 mb-6">
          Full pricing configuration will be available here.
        </p>
        <p className="text-sm text-gray-500">
          For now, we'll set up basic pricing tiers.
        </p>
      </div>

      <div className="flex justify-end">
        <Button onClick={handleSubmit} isLoading={loading} size="lg">
          Continue with Basic Pricing
        </Button>
      </div>
    </div>
  );
};

export default PricingStep;